var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimize2 = function SvgMinimize2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.923 13.48a.594.594 0 0 1 .3.083q.016.007.03.017c.162.107.27.29.27.5v6.233a.6.6 0 0 1-1.2 0v-4.786l-6.25 6.25a.6.6 0 0 1-.847-.85l6.249-6.248H3.688a.6.6 0 1 1 0-1.2zM20.927 2.226a.6.6 0 0 1 .848.847l-6.248 6.248h4.786a.601.601 0 0 1 0 1.2h-6.235a.6.6 0 0 1-.116-.011q-.04-.01-.077-.024l-.035-.01a1 1 0 0 1-.082-.043q-.011-.006-.022-.011a.6.6 0 0 1-.167-.168q-.011-.02-.021-.04a.6.6 0 0 1-.08-.292V3.688a.6.6 0 0 1 1.2 0v4.788z"
  })));
};
export default SvgMinimize2;